/*
 * @Descripttion:
 * @version:
 * @Author: Yj
 * @Date: 2023-07-10 14:12:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-05 17:23:41
 */
const login = {
  'register_byaccount': '注册本源账号',
  'has_byAccount': '已有账号，',
  'go_login': '去登录>',
  'mobileRegister': '手机号注册',
  'emailRegister': '邮箱注册',
  'successTitle': '成功',
  'account_register_suc': '账号信息注册成功',
  'return_login': '返回登录',
  'register_suc_text': '注册成功',
  'register': '注册',
  'confirmPassword': '请确认密码',
  'pwd_placeholder_text': '请输入密码',
  'code_length6': '请输入验证码',
  'phone_length11': '请输入手机号',
  'email_address_suc': '请输入邮箱地址',
  'get_code': '获取验证码',
  'enter_suc_code': '请输入正确的验证码',
  'enter_pwd_two_not_match': '密码不一致，请重新输入',
  'enter_pwd_num_letter': '密码为8-32位字母、数字和特殊符号组合',
  'enter_pwd_error': '密码不符合规范',
  'enter_pwd_length_p': '请输入8-32个字符',
  'enter_pwd_p': '请输入密码',
  'email_valid_err': '邮箱地址不正确',
  'phone_valid_err': '手机号格式不正确',
  'getVerificationCodeSuccess': ' 验证码发送成功',
  'pwd_reset': '重置密码',
  'pwd_phone_reset': '手机号重置',
  'pwd_email_reset': '邮箱重置',
  'pwd_reset_suc': '新密码已重置成功',
  'getCode': '获取验证码',
  'resetSuccess': '密码重置成功',
  'new_confirmPassword': '请确认密码',
  'resetpwd_btn_text': '重置',
  'login_name_text': '请输入手机号/邮箱',
  'pwd': '请输入密码',
  'view': '查看',
  'VerificationCode': '验证码',
  'login_register': '注册',
  'login_forgot_pwd': '忘记密码',
  'new_loginText': '登录',
  'enter_pwd_characters': '8-32个字符',
  'enter_pwd_following': '至少包含两种：大写字母、小写字母、数字、特殊字符',
  'enter_pwd_contain_spaces': '不包含空格',
  'phoneEmptyTip': '请输入手机号',
  'register_tips1': '点击“立即注册”，即表示您同意',
  'register_tips2': '服务条款',
  'register_tips3': '和',
  'register_tips4': '隐私协议',
  login_bg_title: '登录本源量子云账号，感受真实量子计算',
  login_bg_text: '新用户注册即送价值600元量子真机机时',
  login_bg_bottom_line: '登录后可体验',
  login_bg_bottom_Name1: '超导量子计算机真机',
  login_bg_bottom_Text1: '新用户送机时，免费体验',
  login_bg_bottom_Name2: '量子编程框架',
  login_bg_bottom_Text2: '加速量子开发，提高编程效率',
  login_bg_bottom_Name3: '量子计算应用',
  login_bg_bottom_Text3: '超20种量子应用体验',
  login_pwd_register: '前往注册'
};
export default login;
